import { render } from "./BannerUpload.vue?vue&type=template&id=458e22cf&scoped=true&ts=true"
import script from "./BannerUpload.vue?vue&type=script&lang=ts"
export * from "./BannerUpload.vue?vue&type=script&lang=ts"

import "./BannerUpload.vue?vue&type=style&index=0&id=458e22cf&lang=scss&scoped=true"

import exportComponent from "/home/runner/_work/SDD-gotime-web-client/SDD-gotime-web-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-458e22cf"]])

export default __exports__